import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Box,
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { getResponseData } from 'lib/formUtils';
import { ComboPadraoMultiple } from 'views/Components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class ContatoList extends Component {
    state = {
        searchFilter: loadStoredJson('contatoSearchFilter', {
            nomecontato: '',
            situacaoInativoFilter: ANAO,
            desccidade: [],
            estados: [],
            paises: [],
            grupos: []
        }),
        contatos: [],
        listaEstados: [],
        listaPaises: [],
        listaGrupos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('contatoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('contatoRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        await Promise.all([
            this.loadEstadosFiltro(),
            this.loadPaisesFiltro(),
            this.loadGruposContatoFiltro()
        ]);

        this.loadContatos();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('contatoSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('contatoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('contatoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'contatoSearchFilter',
            'contatoPage',
            'contatoRowsPerPage'
        ]);
    };

    /* Carrega os estados */
    loadEstadosFiltro = async () => {
        try {
            const response = await api.get('/estado');
            const estados = getResponseData(response);

            const listaEstados = estados.map(estado => ({
                id: estado.codestado,
                item: estado.sigla ? `${estado.nomeestado} [${estado.sigla}]` : estado.nomeestado
            }));

            this.safeSetState({ listaEstados });

            return listaEstados;
        } catch (error) {
            console.error('Erro ao carregar os estados:', error);

            return [];
        }
    };

    /* Carrega os países */
    loadPaisesFiltro = async () => {
        try {
            const response = await api.get('/pais');
            const paises = getResponseData(response);

            const listaPaises = paises.map(pais => ({
                id: pais.codpais,
                item: pais.nomepais
            }));

            this.safeSetState({ listaPaises });

            return listaPaises;
        } catch (error) {
            console.error('Erro ao carregar os países:', error);

            return [];
        }
    };

    /* Carrega os grupos de contatos */
    loadGruposContatoFiltro = async () => {
        try {
            const response = await api.get('/grupocontato');
            const grupos = getResponseData(response);

            const listaGrupos = grupos.map(grupo => ({
                id: grupo.codgrupocontato,
                item: grupo.descgrupocontato
            }));

            this.safeSetState({ listaGrupos });

            return listaGrupos;
        } catch (error) {
            console.error('Erro ao carregar os grupos de contatos:', error);

            return [];
        }
    };

    /* Carrega os contatos */
    loadContatos = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { desccidade, nomecontato, situacaoInativoFilter } = searchFilter;

        const filtros = [
            {
                field: 'NOMECONTATO',
                value: nomecontato,
                operator: '_like_'
            },
            {
                field: 'INATIVO',
                value: situacaoInativoFilter
            }
        ];

        if (desccidade) {
            filtros.push({
                field: 'DESCCIDADE',
                value: desccidade,
                operator: '_like_'
            });
        }

        if (searchFilter.estados && searchFilter.estados.length > 0) {
            const codigoEstados = searchFilter.estados.map(e => e.id);
            filtros.push({
                field: 'CODESTADO',
                value: codigoEstados.join(','),
                operator: '_in_'
            });
        }

        if (searchFilter.paises && searchFilter.paises.length > 0) {
            const codigoPaises = searchFilter.paises.map(p => p.id);

            filtros.push({
                field: 'CODPAIS',
                value: codigoPaises.join(','),
                operator: '_in_'
            });
        }

        if (searchFilter.grupos && searchFilter.grupos.length > 0) {
            const codigoGrupos = searchFilter.grupos.map(g => g.id);

            filtros.push({
                field: 'GRUPOCONTATO',
                value: codigoGrupos.join(','),
                operator: '_in_'
            });
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: filtros
        });

        try {
            const response = await api.get('/contato' + params);

            this.safeSetState({
                contatos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar os contatos:', error);

            this.safeSetState({
                contatos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadContatos);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadContatos);
    };

    /* Deleta o contato */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/contato/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadContatos();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir o contato!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codcontato, nomecontato) => {
        this.setState({
            open: true,
            selectedId: codcontato,
            selectedDesc: nomecontato
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisa os estados */
    onChangeEstados = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                estados: selected
            },
            page: 0
        });
    };

    /* Pesquisa os países */
    onChangePaises = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                paises: selected
            },
            page: 0
        });
    };

    /* Pesquisa os grupos de contato */
    onChangeGrupos = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                grupos: selected
            },
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nomecontato: '',
            situacaoInativoFilter: ANAO,
            desccidade: '',
            estados: [],
            paises: [],
            grupos: []
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadContatos);
    };

    render() {
        const {
            contatos,
            listaEstados,
            listaGrupos,
            listaPaises,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="nomecontato"
                        name="nomecontato"
                        onChange={this.onChangeSearch}
                        placeholder="Nome do contato"
                        value={searchFilter.nomecontato}
                        style={{
                            flex: '0 1 240px',
                            minWidth: 240
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadContatos}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/crm/contato/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        id="desccidade"
                        name="desccidade"
                        onChange={this.onChangeSearch}
                        placeholder="Cidade"
                        value={searchFilter.desccidade}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200,
                            marginTop: 16
                        }}
                    />

                    <Box
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.estados || []}
                            label="Estado"
                            itens={listaEstados}
                            onSelectionChange={this.onChangeEstados}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.paises || []}
                            label="País"
                            itens={listaPaises}
                            onSelectionChange={this.onChangePaises}
                        />
                    </Box>

                    <Box
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.grupos || []}
                            label="Grupo de contato"
                            itens={listaGrupos}
                            onSelectionChange={this.onChangeGrupos}
                        />
                    </Box>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Nome</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {contatos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={3}
                                                >
                                                    Nenhum contato encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {contatos.map(contato => (
                                            <TableRow
                                                hover
                                                key={contato.codcontato}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(contato.inativo === ASIM) ? redText : {}}
                                                >
                                                    {contato.codcontato}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(contato.inativo === ASIM) ? redText : {}}
                                                >
                                                    {contato.nomecontato}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/crm/contato/${contato.codcontato}`}>
                                                                <EditTwoTone
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/crm/contato/${contato.codcontato}/view`}>
                                                                <VisibilityOutlined
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onClick={() => this.handleOpen(
                                                                    contato.codcontato,
                                                                    contato.nomecontato
                                                                )}
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do contato ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div >
        );
    }
};

export default ContatoList;